import { Component, OnInit, Inject, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteService } from '../../../quote/services/quote.service';
import { Quote } from '../../../shared/models/quote.interface';

export interface QuoteTemplateNameData {
  quote: Quote;
}

@Component({
  selector: 'app-quote-template',
  templateUrl: './quote-template.component.html',
  styleUrls: ['./quote-template.component.scss']
})
export class QuoteTemplateComponent implements OnInit {
  quote: Quote = {} as Quote;
  quoteId: number;
  constructor(private quoteService: QuoteService,
    private dialog: MatDialog) { }

  @Input()
  public set id(value: number) {
    if (value) {
      this.quoteId = value;
    }
  }

  @Output() showList = new EventEmitter<number>();


  ngOnInit(): void {
    this.quoteService.getQuote(this.quoteId)
      .subscribe({
        next: (data) => {
          this.quote = data.quote;
        }
      });
  }

  templateList(id) {
    this.showList.emit(id);
  }

  editTemplate() {
    const dialogRef = this.dialog.open(QuoteTemplateNameDialog, {
      width: '550px',
      data: {
        quote: this.quote
      } as QuoteTemplateNameData
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {

        this.quote.quote_Name = result;
        this.quoteService.saveQuote(this.quote)
          .subscribe({
            next: (data) => {
            }
          });
      }
    });
  }
}

@Component({
  selector: 'quote-template-name.dialog',
  templateUrl: 'quote-template-name.dialog.html',
})
export class QuoteTemplateNameDialog {

  templateName: string;

  constructor(public dialogRef: MatDialogRef<QuoteTemplateNameDialog>,
    @Inject(MAT_DIALOG_DATA) public data: QuoteTemplateNameData) {
    
    this.templateName = data.quote.quote_Name;
  }

  printReport(): void {
    this.dialogRef.close(this.templateName);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
